<template>
  <el-col
    class="content"
    :xl="{ span: 18 }"
    :lg="{ span: 18 }"
    :md="{ span: 18 }"
    :xs="{ span: 24 }"
    :sm="{ span: 24 }"
  >
    <div class="mydoc">
      <div class="header" style="font-weight: 900">
        第二届“语言实验之星奖”评奖通告
      </div>
      <div class="mybody">
        <p>
          为加快中国实验语言学的发展，鼓励青年学子走上语言研究科学化的道路，激发青年学子积极性、主动性、创造性，特设“语言实验之星”奖。由《实验语言学》编辑部和南开大学语言所聘请知名专家担任评审委员进行评奖。
        </p>
        <p>
          第二届“语言实验之星”奖将于2025年1月前评出。
        </p>
        <p>
          凡从事语言实验的博士生、硕士生和本科生在学期间或毕业后一年内以第一作者身份于2023年1月至2024年9月间公开发表的的学术论文均可参与评奖。申请参评的成果需要有两位推荐人（副高及以上职称推荐）推荐。
        </p>
        <p>
          “语言实验之星”评奖章程以及推荐书均可通过《实验语言学》网站（http://www.exp-linguistics.com/）“语言实验之星”奖栏目中下载。推荐人的意见书，以及被推荐成果的电子版全文和作者简介，请于2024年9月30日前发到E-mail：SYlinguistics@163.com。
        </p>
        <p>“语言实验之星”奖办公室</p>
        <p>2024年6月6日</p>
        <p>
          <span
            style="cursor: pointer; color: #006a71"
            @click="downloadPaper()"
            >”语言实验之星“奖推荐表下载</span
          >
        </p>
<!--        <p>-->
<!--          <span-->
<!--            style="cursor: pointer; color: #006a71"-->
<!--            @click="downloadPrizeRules()"-->
<!--          >“语言实验之星”评奖章程下载</span-->
<!--          >-->
<!--        </p>-->
      </div>
    </div>
  </el-col>
</template>>

<script>
import loginComponent from "@/components/loginComponent";

export default {
  name: "star",
  components: {
    loginComponent,
  },
  data() {
    return {}
  },
  methods: {
    downloadPaper () {
      window.open(
        "http://www.exp-linguistics.com/file/”语言实验之星“奖推荐表.doc",
        "_blank"
      )
    },
    // downloadPrizeRules () {
    //   window.open(
    //     "http://www.exp-linguistics.com/file/赵元任语言实验之星奖推荐书.docx",
    //     "_blank"
    //   )
    // }
  }
};
</script>

<style lang="scss" scoped>
.el-row {
  //   background-color: white;
  margin: auto;
}

.introduction_pre {
  width: auto;
  margin: 10px 5px 10px 5px; /**边框距离 上右边下左 */
  background-color: white;
  overflow: hidden;
}
.introduction {
  border: 1px solid #b3c0d1;
  height: 920px;
  margin-bottom: 10px;
  border-radius: 5px;
  /* margin-top: 5px; */
}

.about {
  min-height: calc(100vh - 8rem);
}
.showappbox {
  display: flex;
  .left {
    text-align: left;
  }
}

.content {
  margin-top: 12px;
  .mylink {
    height: 18rem;
    border-radius: 4px;
    background: rgba($color: #ffffff, $alpha: 0.5);
    box-shadow: 2px 3px 10px rgb(51, 72, 94);
    .mybody {
      //   padding: 10px;
      display: flex;
      align-items: center;
      justify-content: space-around;
      .body-item {
        cursor: pointer;
      }
      .num {
        font-size: 55px;
        font-weight: bold;
      }
    }
  }
  .mydoc {
    border-radius: 4px;
    min-height: 20rem;
    box-shadow: 2px 3px 10px rgb(51, 72, 94);
    text-align: left;
    .mybody {
      //   background: linear-gradient(45deg, #34495e, #41b883);
      height: 940px;
      padding: 10px;
      background-color: white;
      overflow: auto;
    }
    p {
      color: black;
      text-indent: 30px;
      line-height: 24px;
      padding: 10px;
    }
  }
}
.header {
  padding: 10px;
  text-align: left;
  background-color: gainsboro;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  border-bottom: 1px solid gainsboro;
}
</style>



// WEBPACK FOOTER //
// src/view/star.vue